import React, { useState, useEffect } from 'react';

interface LoadingScreenProps {
  isLoading?: boolean;
  children?: React.ReactNode;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ isLoading = true, children }) => {
  const [shouldShow, setShouldShow] = useState(isLoading);

  useEffect(() => {
    if (isLoading) {
      setShouldShow(true);
    } else {
      // Delay hiding to allow for smooth transition
      const timer = setTimeout(() => {
        setShouldShow(false);
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  return (
    <>
      <div 
        className={`fixed inset-0 bg-white dark:bg-gray-900 flex items-center justify-center z-50 transition-opacity duration-150 ${
          shouldShow ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="text-center">
          <img 
            src="/branding/TriEvents_Loading_Big_Text.gif" 
            alt="TriEvents Loading" 
            className="mx-auto w-64 md:w-[500px] h-auto"
          />
        </div>
      </div>
      <div className={`transition-opacity duration-150 ${shouldShow ? 'opacity-0' : 'opacity-100'}`}>
        {children}
      </div>
    </>
  );
};

export default LoadingScreen; 